import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private config: any;

  constructor(
    private http: HttpClient
  ) { }

  loadConfig(): Promise<any> {
    return fetch('/assets/configuration/configuration.json')
      .then(response => response.json())
      .then(data => {
        this.config = data;
        return data;
      })
      .catch(err => {
        console.error("Error loading config:", err);
        return null;
      });
  }

  // loadConfig() {
  //   return this.http.get('/assets/configuration/configuration.json')
  //     .toPromise()
  //     .then((data: any) => {
  //       this.config = data;
  //       console.log("config: " + this.config.pass)
  //     });
  // }

  // loadConfig(): Observable<any> {
  //   return this.http.get('/assets/configuration/configuration.json').pipe(
  //     catchError((error) => {
  //       console.error('Error loading config:', error);
  //       throw error; // Or return default configuration
  //     })
  //   );
  // }

  get setting() {
    return this.config;
  }
}